import type { AnalyticsConfig } from './types'

export const analyticsConfig: AnalyticsConfig = {
  enabled: import.meta.env.VITE_ENABLE_ANALYTICS === 'true',
  ga4: {
    measurementId: import.meta.env.VITE_GA_MEASUREMENT_ID || '',
  },
  meta: {
    pixelId: import.meta.env.VITE_META_PIXEL_ID || '',
  },
  debug: import.meta.env.DEV,
}
